// import { StateReducers } from 'state/reducers/types/StateReducers'

import {
  // EditorEmojiButtonConnectedProps,
  EditorEmojiButtonMapStateReturnType,
} from './types'

export const EditorEmojiButtonMapState = (): // state: StateReducers,
// props: EditorEmojiButtonConnectedProps,
EditorEmojiButtonMapStateReturnType => {
  // const currentLocation = state.currentLocation || undefined
  // const isRoutes = currentLocation && currentLocation.isRoutes
  // return { isRoutes }

  return {}
}
